import { date, nullable, string } from '@sda/sdk/helpers/types.bitmasks';

export const FeedbackMask = {
  createdAt: date,
  updatedAt: date,

  body: string,
  owner: string,
  selectedProfileId: string,
  selectedProfileType: string,
  showId: string,
  targetProfileId: string,
  targetProfileType: string,
  typeformId: string | nullable,
};
